import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useMediaQuery } from "@material-ui/core/";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { useTheme } from "@material-ui/core/styles";
import { useTranslate, useNotify, useMutation } from "react-admin";
import { Form } from "react-final-form";
import SimpleSaveButton from "./SimpleSaveButton";
import { AddressForm } from "../../admin/components/AddressForm";
import { CUSTOM_POST } from "../../restProvider";

const useStyles = makeStyles((theme) => ({
    dialog: {
        textAlign: "center",
        padding: theme.spacing(2, 4),
        [theme.breakpoints.down(400)]: {
            padding: theme.spacing(0, 0),
        },
    },
    dialogActions: {
        padding: theme.spacing(2, 2),
        textAlign: "center",
        justifyContent: "center",
    },
    title: {
        marginTop: 0,
        marginBottom: 0,
    },
    content: {
        [theme.breakpoints.up("md")]: {
            width: 570,
        },
    },
}));

const PaiementChancellerieModal = ({
    open,
    handleClose,
    requestId,
    amount = 350,
    location,
    firstName,
    lastName,
}) => {
    const classes = useStyles();
    const translate = useTranslate();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));
    const notify = useNotify();
    const [submitted, setSubmitted] = useState(false);
    const [pay, { loading: payFormLoading }] = useMutation();

    const submit = async (values) => {
        try {
            await new Promise((resolve, reject) => {
                pay(
                    {
                        type: CUSTOM_POST,
                        resource: "inductionrequest/payment",
                        payload: {
                            data: {
                                id: requestId,
                                ...values,
                                returnUrl: `/#${location?.pathname || ""}`,
                            },
                        },
                    },
                    {
                        onSuccess: (...args) => {
                            resolve(args);
                            try {
                                const elem = document.createElement("div");
                                elem.innerHTML = args[0].data;
                                const htmlForm = elem.firstChild;
                                document.body.appendChild(htmlForm);
                                htmlForm.submit();
                                setSubmitted(true);
                            } catch (e) {
                                console.error(e);
                                setSubmitted(false);
                            }
                        },
                        onFailure: (error) => {
                            reject(error);
                        },
                    }
                );
            });
        } catch (error) {
            notify(error.message, "error");
        }
    };

    return (
        <Form
            onSubmit={submit}
            render={({ handleSubmit, invalid }) => (
                <form>
                    <Dialog
                        className={classes.dialog}
                        open={open}
                        onClose={handleClose}
                        fullScreen={fullScreen}
                        aria-labelledby="chancellerie-payment-title"
                        maxWidth="md"
                    >
                        <DialogTitle
                            id="chancellerie-payment-title"
                            className={classes.title}
                            disableTypography
                        >
                            <h2 className={classes.title}>
                                {translate("Payer des droits de chancellerie")}
                            </h2>
                            {firstName || lastName ? (
                                <div>
                                    {translate("pour")} {firstName} {lastName}
                                </div>
                            ) : null}
                        </DialogTitle>
                        <DialogContent className={classes.content}>
                            <h3>{translate("billing.billing address")}</h3>
                            <AddressForm classes={classes} />
                        </DialogContent>
                        <DialogActions className={classes.dialogActions}>
                            <Button
                                onClick={handleClose}
                                variant="outlined"
                                color="secondary"
                                autoFocus
                            >
                                {translate("Fermer")}
                            </Button>
                            <SimpleSaveButton
                                variant="contained"
                                color="secondary"
                                invalid={invalid}
                                disabled={submitted}
                                handleSubmitWithRedirect={(...args) =>
                                    handleSubmit(...args)
                                }
                                saving={payFormLoading}
                                submitOnEnter
                                icon={null}
                                label={translate("Payer")}
                            >
                                {translate("Payer {{amount}}€", { amount })}
                            </SimpleSaveButton>
                        </DialogActions>
                    </Dialog>
                </form>
            )}
        />
    );
};

export default PaiementChancellerieModal;
